import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import RegisterEvento from './RegisterEvento.vue'
import RegisterFidelizacion from './RegisterFidelizacion.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const { state } = useStore<VuexStore>(key)

return (_ctx: any,_cache: any) => {
  return (_unref(state).evento?.fidelizacion)
    ? (_openBlock(), _createBlock(RegisterFidelizacion, { key: 0 }))
    : (_openBlock(), _createBlock(RegisterEvento, { key: 1 }))
}
}

})